import { setProps } from '../props';
import fetchUsers from '../../../Core/Services/fetchUsers';
import initialize from '../Services/initialize';

export default (props) => (dispatch) => {

  setProps(props);

  dispatch(fetchUsers());

  dispatch(initialize());
  
}